import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { I18n } from "@shared/modules/utils/LangUtil";
import EventService from "@shared/services/EventService";

class OtpOptionsPopup extends Component {
    constructor() {
        super();
        this.state = {
            propsData: null,
            disableSave: false,
            loading: false
        };
    }

    onChangeChannelRadio = (e, contactType, maskedVal) => {
        if (this.props.saveCallback) this.props.saveCallback(contactType, maskedVal);
        EventService.publish("globalModal.hide");
    };

    render() {
        return (
            <div className={`otp-options-popup ${this.state.loading ? "loading-inline" : ""}`}>
                <h1>{I18n("g.lbl.sgnup_destin")}</h1>
                <div className="popup-wrapper">
                    <div className="col">
                        {(this.props.data || [{ contactType: "sms", maskedValue: "*****", verified: true }]).map(v => (
                            <div style={{ display: "flex", gap: "20px" }}>
                                <label className="radio">
                                    <input
                                        type="radio"
                                        id={v.contactType}
                                        value={v.contactType}
                                        name="addressGroup"
                                        onChange={e => this.onChangeChannelRadio(e, v.contactType, v.maskedValue)}
                                    />
                                    <span />
                                    <div className="label"></div>
                                    <div className="value"></div>
                                </label>
                                <label className="radioLabel" htmlFor={v.contactType}>
                                    <span className="label">{I18n("g.lbl.label_" + v.contactType)}</span>
                                    <br />
                                    <span className="value">{v.maskedValue}</span>
                                    <br />
                                    <span className="value">
                                        <span className={`svg-icon ${v.verified ? "verified" : "not-verified"}`}>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                height="22px"
                                                viewBox="0 0 700 700"
                                                width="22px"
                                            >
                                                <path d="m502.43 172.55c3.2578 3.2773 5.0898 7.7148 5.0898 12.336 0 4.625-1.832 9.0586-5.0898 12.34l-137.55 137.55v-.003906c-3.3008 3.2773-7.7734 5.1016-12.426 5.0781h-2.4492c-5.1953-.53516-9.8789-3.3594-12.773-7.7031l-54.949-82.426-.003906.003906c-2.8906-3.8438-4.0703-8.7109-3.2656-13.453.80469-4.7383 3.5273-8.9414 7.5234-11.613 4-2.6758 8.9219-3.5859 13.613-2.5195 4.6875 1.0703 8.7344 4.0195 11.18 8.1602l43.227 64.75 122.5-122.5c3.3047-3.4805 7.8906-5.4492 12.688-5.4492s9.3828 1.9688 12.688 5.4492zm-12.426 87.5c-4.6406 0-9.0938 1.8438-12.375 5.125s-5.125 7.7344-5.125 12.375v2.4492c-.14062 36.359-16.426 70.781-44.449 93.945-28.027 23.168-64.895 32.688-100.63 25.984-35.734-6.7031-66.648-28.934-84.375-60.684-17.727-31.746-20.434-69.727-7.3867-103.67 13.047-33.938 40.496-60.328 74.922-72.031s72.27-7.5078 103.3 11.453c3.9766 3.1328 9.1133 4.3906 14.086 3.4492 4.9727-.94141 9.2969-3.9922 11.852-8.3594 2.5547-4.3711 3.0938-9.6328 1.4766-14.43-1.6172-4.7969-5.2344-8.6562-9.9141-10.586-40.008-24.145-88.672-29.273-132.84-14.004-44.164 15.266-79.27 49.359-95.824 93.059-16.555 43.695-12.852 92.492 10.113 133.19 22.961 40.699 62.809 69.102 108.77 77.527 45.961 8.4258 93.293-3.9922 129.2-33.902 35.906-29.906 56.676-74.211 56.699-120.94v-2.2734c0-4.6445-1.8438-9.0938-5.125-12.375s-7.7344-5.125-12.375-5.125z" />
                                            </svg>
                                            {v.verified ? "Verified" : "Not-verified"}
                                        </span>
                                    </span>
                                </label>
                                <div className="clear"></div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(OtpOptionsPopup);
